import { render } from "./App.vue?vue&type=template&id=ca573336"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ca573336&lang=scss"

import exportComponent from "E:\\WORKING\\0004-WEB\\RD_Management\\rd_notepad_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__